import React from 'react'
import ReactDOM from 'react-dom';
import FilterCheckboxOption from 'components/bid_history/filterCheckboxOption';
import Checkbox from 'components/marketplace/checkbox';

class BidHistoryFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const classList = event.target.className;
    if (classList.indexOf("active") >= 0) {
      event.target.classList.remove("active")
    } else {
      event.target.classList.add("active")
    }
  }

  render() {
    const { filterOptions, handleCheckbox, selectedMakes, selectedModels, selectedStatus, selectedGroups } = this.props;
    let makes = [];
    let models = [];
    let status = [];
    let product_type = [];
    if (filterOptions.length !== undefined) {
      makes = filterOptions[0].filter((item, position) => { return filterOptions[0].indexOf(item)== position })
      models = filterOptions[1].filter((item, position) => { return filterOptions[1].indexOf(item) == position })
      status = filterOptions[2].filter((item, position) => { return filterOptions[2].indexOf(item) == position })
      product_type = filterOptions[3].filter((item, position) => { return filterOptions[3].indexOf(item) == position })
    }

    return (
      <div>
        <div className="search-option">
          <FilterCheckboxOption option={'selectedMakes'} name={'Make'} type={makes} handleCheckbox={handleCheckbox} selectedValues={selectedMakes}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedModels'} name={'Model'} type={models} handleCheckbox={handleCheckbox} selectedValues={selectedModels}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedGroups'} name={'Product Group'} type={product_type} handleCheckbox={handleCheckbox} selectedValues={selectedGroups}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedStatus'} name={'Status'} type={status} handleCheckbox={handleCheckbox} selectedValues={selectedStatus}/>
        </div>
      </div>
    )
  }
};

export default BidHistoryFilter;
